import React,{Component} from 'react';

export  class Controls extends Component {
	render() {
		return(
				<div>
        		<h1 style={{textAlign:'center', color: '#99AAAB'}}> 
        			Welcome To YouTube video Fetching App
        		</h1>
	
				</div>
                         
			); 
	}
} 
